<template>
  <div class="content-card-categories">
    <div class="content-card-categories--image" v-if="category.picture" :style="{ background: `url(data:image/jpg;base64,${category.picture})` }"></div>
    <div class="content-card-categories--text">
      <h2>{{ category.name }}</h2>
    </div>
    <div class="content-card-categories--btns">
      <button class="btn--edit" @click="changeModalCategory(category, 'edit')">
        Editar
      </button>
      <button class="btn--delete" @click="changeModalCategory(category, 'delete')">
        Excluir
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ['category', 'isType'],
  methods: {
    ...mapActions('Plans', ['registerCategoryPlans']),
    ...mapActions(['setModalCategory']),
    changeModalCategory(category, type) {
      let obj = {isType: this.isType, data: category };
      this.setModalCategory(obj);
      type === 'edit' ? this.$bvModal.show('modal-category') : this.$bvModal.show('modal-delete-default');
    },
  }
}
</script>

<style lang="scss">
.content-card-categories {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 200px;
  background: var(--white);
  border-radius: 10px;
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  padding-bottom: 15px;
  margin-bottom: 50px;
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 10px 10px 0px 0px;
  }
  &--text {
    padding: 40px 15px 0px 15px;
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      text-align: center;
      height: 75px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 0;
    }
  }
  &--btns {
    padding: 0px 15px;
    display: flex;
    align-items: center;
    .btn--edit, .btn--delete {
      width: 50%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: 'Font Bold';
      text-transform: uppercase;
      border: 0;
      border-radius: 30px;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.6;
      }
    }
    .btn--edit {
      margin-right: 5px;
      background: var(--yellow);
      color: var(--black);
    }
    .btn--delete {
      margin-left: 5px;
      background: var(--red-2);
      color: var(--white);
    }
  }
}
</style>
